import BasicAutoQueryController from "servicestack/auto-query/auto-query.controller";
import User from "emun.auth/users/user.model";
import modals from "webmodals/modals";
import changePasswordPrompt from "emun.auth/change-password/change-password-prompt";
import { AuthPrompt } from "emun.auth/auth-prompt";
import userEditorPrompt from "emun.auth/users/user-editor-prompt";
import labels from "emun.auth/users/_labels";
import userMarketingProfilePrompt from "emun.auth/users/user-marketing-profile-prompt.es6";
import authConfig from "emun.auth/auth.config";

export default class UserManagerController extends BasicAutoQueryController {
  constructor() {
    super();
    const $ctrl = this;
    //$ctrl.config = retailerConfig;
    $ctrl.config = authConfig;
    $ctrl.prompt = $ctrl.authPrompt = new AuthPrompt();
    $ctrl.labels = labels;
  }

  getQuery() {
    const $ctrl = this;
		const retailerId = $ctrl.retailerId || $ctrl.customerId;
    const vendorId = $ctrl.vendorId;
    return {
      url: `QueryUsers.json`,
      orderBy: "-LastLogInAttempt,Id",
      pageSize: 24,
      filters: [
        //{ groupBy: "roles", title: labels.role },
        { date: "CreatedDate", title: labels.createdDate },
        { date: "LastLogInAttempt", title: labels.lastLoginAttempt },
        {
          radio: "RoleLookup",
          title: "Role",
          collapsed: true,
          $onInit(g) {
            g.bus
              .send("QueryRoles.json?op=UserManagerController")
              .then((res) => {
                g.options = res.data.results.map((role) => ({
                  fieldName: g.radio,
                  label: role.name,
                  description: role.description,
                  isSelected: (g) => g.query.criteria[g.radio] === role.code,
                  toggle: (g) => {
                    if (g.query.criteria[g.radio] !== role.code) {
                      g.query.criteria[g.radio] = role.code;
                      g.query.load();
                    } else {
                      delete g.query.criteria[g.radio];
                      g.query.load();
                    }
                  },
                  value: () => role.code,
                }));
              });
          },
        },
      ],
      hideLeftNav: true, // $ctrl.$pageConfig.is('gt-sm'),
      autoLoad: true,
      append: false,
      disableQueryString: !!$ctrl.disableQueryString,
      criteria: {
        active: true,
        RetailerId: vendorId || retailerId,
        // ...$stateParams,
        // context: $stateParams.context || "Manage"
      },
      scrub(response) {
        response.data.results = response.data.results.map((m) => new User(m));
      },
      // THESE SORT OPTIONS ARE USED IN BOTH THE CUSTOMER USERS MODULE AND THE ADMIN USERS MODULE. THESE ARE THE ONLY COLUMNS THAT ARE USED IN BOTH AS OF 8-8-2019
      sortOptions: {
        "DisplayName,Id": "Display Name: A to Z",
        "-DisplayName,Id": "Display Name: Z to A",
        "Email,Id": "Email: A to Z",
        "-Email,Id": "Email: Z to A",
        "CreatedDate,Id": "Created On: Newest",
        "-CreatedDate,Id": "Created On: Oldest",
        "LastLogInAttempt,Id": "Last Login: Newest",
        "-LastLogInAttempt,Id": "Last Login: Oldest",
        "LockedDate,Id": "Date Locked: Newest",
        "-LockedDate,Id": "Date Locked: Oldest",
      },
    };
  }

  impersonate(user) {
    return this.$session.impersonateUser(user);
  }

  impersonateUser(user) {
    return this.$session.impersonateUser(user);
  }

  syncUsers() {
    const $ctrl = this;
    return $ctrl.$modals
      .confirm(`Are you sure you would like to sync all users`, "Sync Users")
      .result.then(function () {
        $ctrl.$notify.info(`Syncing users...`, {
          //title: "Syncing users",
          ttl: 5000,
        });
        return $ctrl.$session.bus
          .send(`ReconcileDb.json?Tables=UserAuth,UserAuthDetails`)
          .then(({ data }) => {
            $ctrl.$notify.success(`Users have been synced!`, {
              //title: "Reset Password",
              ttl: 5000,
            });
            $ctrl.query.load();
          });
      });
  }

  resetPassword(user) {
    const $ctrl = this;
    if (!user.email)
      return modals.alert(
        "Please provide an email address for this user",
        "Email Required"
      );
    return modals
      .confirm(
        `Are you sure you would like to reset the password of ${user.email}?`,
        "Reset Password"
      )
      .result.then(function () {
        return $ctrl.$session.bus
          .send(`ResetPassword.json`, user)
          .then(({ data }) => {
            $ctrl.$notify.success(
              `A verification code was emailed to: ${user.email}`,
              {
                title: "Reset Password",
                ttl: 5000,
              }
            );
          });
      });
  }

  registrationResetPassword(user) {
    const $ctrl = this;
    if (!user.email)
      return modals.alert(
        "Please provide an email address for this user",
        "Email Required"
      );
    user.fromRegistration = true;
    return modals
      .confirm(
        `Are you sure you would like to reset the password of ${user.email}?`,
        "Reset Password"
      )
      .result.then(function () {
        return $ctrl.$session.bus
          .send(`ResetPassword.json`, user)
          .then(({ data }) => {
            $ctrl.$notify.success(
              `A verification code was emailed to: ${user.email}`,
              {
                title: "Reset Password",
                ttl: 5000,
              }
            );
          });
      });
  }

  changePassword(model) {
    console.info("changePassword", model, this);
    return changePasswordPrompt({
      id: model.id,
      userAuthId: model.id,
    });
  }

  deleteUser(user, refreshOnly) {
    const $ctrl = this;
    return modals
      .confirm(
        "Please confirm your desire to delete this user.  This cannot be undone.",
        user.displayName
      )
      .result.then(() =>
        $ctrl.bus.send("DeleteUser.json", user).then(() => {
          $ctrl.query.load(true);
        })
      );
  }

  lockUser(user) {
    const $ctrl = this;
    return modals.confirm("Lock user", user.displayName).result.then(() => {
      return $ctrl.bus
        .send("LockUser.json?Id=" + user.id)
        .then((res) => $ctrl.mutliView("locked", true));
    });
  }

  unlockUser(user, redirect = true) {
    const $ctrl = this;
    return modals.confirm("Unlock user", user.displayName).result.then(() => {
      return $ctrl.bus.send("UnlockUser.json?Id=" + user.id).then((res) => {
        if (redirect) $ctrl.mutliView("unlocked", true);
        else $ctrl.query.load();
      });
    });
  }

  mutliView(msg, reload) {
    const $ctrl = this;
    msg && console.warn(msg);
    reload && $ctrl.query.load();
    $ctrl.$state.transitionTo("users.multi-view.list");
  }

  addUser() {
    this.$state.transitionTo("users.editor", { userId: "-1" });
  }

  editUser(id) {
    this.$state.transitionTo("users.editor", { userId: id });
  }
  showMarketingProfile(user) {
    return userMarketingProfilePrompt({user: user});
  }
  add() {
    const $ctrl = this;
		const retailerId = $ctrl.retailerId || $ctrl.customerId;
    return userEditorPrompt({
      title: "Create user...",
      subTitle: retailerId,
      hideRole: true,
      user: {
        retailerId: this.vendorId || this.retailerId,
        vendorId: this.vendorId,
        retailer: { id: this.retailerId },
        vendor: {id: this.vendorId},
        role: $ctrl.vendorId ? "Vendor" : "Retailer",
      },
    }).then(() => $ctrl.query.load(true));
  }
  edit(user) {
    const $ctrl = this;
    return userEditorPrompt({
      title: "Edit User...",
      hideRole: true,
      subTitle: user.displayName || user.fullNamee || user.userName,
      user,
    }).then(() => $ctrl.query.load(true));
  }
}
